import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getAssetLevelUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/asset_level`;

const toggleAssetLevelUrl = (alId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/asset_level/${alId}/toggle`;

const getAssetLevelByIdUrl = (alId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/asset_level/${alId}`;

const updateAssetLevelUrl = (alId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/asset_level/${alId}`;

const addAssetLevelUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/asset_level`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getAssetLevelUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(asset_levelId, companyId, subcompanyId) {
    const url = toggleAssetLevelUrl(asset_levelId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(asset_levelId, companyId, subcompanyId) {
    const url = getAssetLevelByIdUrl(asset_levelId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(asset_levelId, companyId, subcompanyId, asset_level) {
    const url = updateAssetLevelUrl(asset_levelId, companyId, subcompanyId);
    return this.axios
      .put(url, asset_level, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, asset_level) {
    const url = addAssetLevelUrl(companyId, subcompanyId);
    return this.axios
      .post(url, asset_level, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/asset_level.api.js